import { useContext } from 'react';
import { TableContext } from '../../TableContext';
import classes from './Row.module.scss';

export default function Row({ withLines = false, children }) {
  const ctx = useContext(TableContext);

  return (
    <div className={`${classes.row} ${withLines ? classes.withBorder : ''}`} style={{ ...ctx.gridStyles }}>
      {children}
    </div>
  );
}
